import announcements from "./announcements";

export default announcements;
